import { FC } from 'react';

import Button from 'components/_core/Button';
import BackButton from 'components/BackButton';
import { INTERCOM_LAUNCHER_CLASS_NAME } from 'features/Intercom';

import locales from './locales';
import * as S from './styles';
import { Props } from './types';

const ContactSupport: FC<Props> = ({ body, title }) => (
  <>
    <BackButton marginBottom="space-24" />

    <S.Title>{title}</S.Title>
    <S.Body>{body}</S.Body>
    <Button
      alignSelf="flex-start"
      className={INTERCOM_LAUNCHER_CLASS_NAME}
      marginTop="space-32"
    >
      {locales.contactSupport}
    </Button>
  </>
);

export default ContactSupport;
